import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * Teen 1-day card overlay for VideoBox — reference markup:
 * .casino-video-cards > .casino-cards-shuffle + .casino-video-cards-container
 * (h4 Player A, 3 cards, h4 Player B, 3 cards). Styled by index.css.
 * Card ordering: 1-day = A=[0,2,4], B=[1,3,5] from 6-card string.
 */
export default function Teen1DayCardsOverlay({ normalizedResultData }) {
  const [showCards, setShowCards] = useState(true);
  const cards = String(normalizedResultData || "")
    .split(",")
    .map((c) => c.trim())
    .filter(Boolean);

  const playerACards = [0, 2, 4].map((i) => cards[i]).filter(Boolean);
  const playerBCards = [1, 3, 5].map((i) => cards[i]).filter(Boolean);

  const allPlaceholder =
    cards.length === 0 ||
    cards.every((c) => !c || c === "0" || c === "1");

  if (allPlaceholder) {
    if (!showCards) setShowCards(true); // new round re-opens a hand-closed strip
    return null;
  }

  return (
    <div className={`casino-video-cards${showCards ? "" : " hide-cards"}`}>
      <div className="casino-cards-shuffle" onClick={() => setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>
      <div className="casino-video-cards-container">
        <h4 className="text-left text-white text-uppercase">Player A</h4>
        <div>
          {playerACards.map((token, idx) => (
            <span key={`a-${idx}`}>
              <CardImg src={getCardImage(token)} alt="" />
            </span>
          ))}
        </div>
        <h4 className="text-left text-white text-uppercase">Player B</h4>
        <div>
          {playerBCards.map((token, idx) => (
            <span key={`b-${idx}`}>
              <CardImg src={getCardImage(token)} alt="" />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
